import { TOGGLED, OPENED, CLOSED } from './constants'

export const toggleMenu = () => ({ type: TOGGLED })
export const openMenu = () => ({ type: OPENED })
export const closeMenu = () => ({ type: CLOSED })



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/open/actions.js